import store from "../../../core/store";

export const listPartnerMembers = () => {
    return store.dispatch({
		action: "table.partner_members/LIST_PARTNER_MEMBERS",
		method: "GET",
		endpoint: "/companies/partner/members",
		main: true
	});
};